export const WORKER_SOLUTIONS = [
  {
    id: "campaign-manager",
    title: "For Campaign Managers",
    image: "/images/tailored-solutions/manager.webp",
    problem: "Time-consuming outreach, low engagement",
    solution:
      "Reaching out to voters is one of the most important parts of any campaign because it builds trust, addresses their concerns, and motivates them to take action. Reach makes this process easier than ever by automating key outreach tasks like grouping voters and sending personalized messages.",
  },
  {
    id: "candidate",
    title: "For Candidates",
    image: "/images/tailored-solutions/candidate.webp",
    problem: "Weak voter connection, unclear messaging",
    solution:
      "Your ultimate goal is to earn the trust and votes of as many people as possible. Reach helps you achieve this by automatically matching sections of your platform to voters' individual priorities and concerns. This approach builds stronger connections and drives more votes.",
  },
  {
    id: "strategist",
    title: "For Strategists",
    image: "/images/tailored-solutions/strategist.webp",
    problem: "Limited insights, poor targeting",
    solution:
      "Winning campaigns rely on smart, data-driven decisions. Reach provides real-time insights into voter sentiment and engagement, enabling you to refine messaging and target audiences with precision. This is important for large state-wide/national campaigns as well as small, regional campaigns.",
  },
  {
    id: "comms",
    title: "For Comms Professionals",
    image: "/images/tailored-solutions/comms.webp",
    problem: "Ineffective messaging, low ROI",
    solution:
      "Every dollar spent on communication should deliver measurable results. Reach helps you create authentic connections with your voters and supporters based on their biggest concerns. Reach will take the guesswork out of figuring out which messages will resonate with your audience.",
  },
  {
    id: "fundraiser",
    title: "For Fundraisers",
    image: "/images/tailored-solutions/fundraiser.webp",
    problem: "Generic pitches, low conversion",
    solution:
      "Reach increases donation amounts and expands your pool of potential donors by automatically tailoring each pitch to match the interests, concerns, and demographics of prospective donors. This makes your fundraising more compelling and relatable.",
  },
];
